import { defineComponent as _defineComponent } from 'vue'
import { ref, type Ref } from 'vue';
import { useClickOutside } from '@/composables/clickOutside';
import ColorSelector from '../ColorSelector.vue';
import type { FontColorOption } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';


export default /*#__PURE__*/_defineComponent({
  __name: 'QrColorPicker',
  props: {
    label: null,
    color: null,
    disabled: { type: Boolean }
  },
  emits: ["color-selected"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'color-selected', color: FontColorOption): void;
}), expose: any, slots: any, attrs: any }) {





const pickerRef: Ref<HTMLElement | undefined> = ref();

const { clickOutsideActive } = useClickOutside(
    pickerRef,
    () => {
        clickOutsideActive.value = false;
    },
    false
);

const togglePicker = () => {
    if (!clickOutsideActive.value) clickOutsideActive.value = true;
    else clickOutsideActive.value = false;
};

const onColorSelected = (color: FontColorOption) => {
    emit('color-selected', color);
    clickOutsideActive.value = false;
};

return { __sfc: true,emit, pickerRef, clickOutsideActive, togglePicker, onColorSelected, ColorSelector }
}

})